import { render, staticRenderFns } from "./ProductIngredients.vue?vue&type=template&id=3daa77f6"
import script from "./ProductIngredients.vue?vue&type=script&lang=js"
export * from "./ProductIngredients.vue?vue&type=script&lang=js"
import style0 from "./ProductIngredients.vue?vue&type=style&index=0&id=3daa77f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports